import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import Landing from './components/Landing';
import Course from './components/Course';
import Iframe from './components/Iframe';
import Playlist from './components/Playlist';
function App() {
	return (
		<Router>
			<Routes>
				<Route path='/home/:id' element={<Home />}></Route>
				<Route path='/course' element={<Course />}></Route>
				<Route path='/frame' element={<Iframe />}></Route>
				<Route path='/playlist' element={<Playlist />}></Route>
				<Route path='/' element={<Landing />}></Route>
			</Routes>
		</Router>
	);
}

export default App;
